import React, { useState } from "react";
import { BaseButton } from "src/components/ui/baseButton";
import { FileDownloadIcon } from "../icons";
import { Text } from "src/components/ui/Text";
import DialogDownloadCSV from "../dialogs/DialogDownloadCSV";
import { useDempStore } from "src/context/stores";
import { downloadVehicleOverviewReport } from "src/api/company";

const BtnVehicleReport = ({selectedRange}) => {
    const [plantId] = useDempStore((state) => [state.plantId]);
    const [isLoading, setIsLoading] = useState(false);

    const onClickDownload = async () => {
          try {
            setIsLoading(true);
            
            const { data, error } = await downloadVehicleOverviewReport(plantId, selectedRange);
            
            if (error) {
              // console.error("API Error:", error);
              alert("Failed to download the report: " + (error.message || "Unknown error"));
              return;
            }
            
            
            if (data && data.download_url) {
              const url = data.download_url;
              const link = document.createElement("a");
              link.href = url;
              link.download = `vehicle_overview_report_${selectedRange}.xlsx`;
              link.target = "_blank";
              
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            } else if (data && typeof data === 'string' && data.startsWith('http')) {
              const link = document.createElement("a");
              link.href = data;
              link.download = `vehicle_overview_report_${selectedRange}.xlsx`;
              // link.target = "_blank";
              
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            } else if (data && data.blob) {
              const blob = new Blob([data.blob], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.download = `vehicle_overview_report_${selectedRange}.xlsx`;
              
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
                         } else {
              //  console.error("Unexpected data format:", data);
               alert("Unexpected response format from server");
             }
           } catch (error) {
            //  console.error("Download error:", error);
             alert("Failed to download the report, please try again...");
           } finally {
             setIsLoading(false);
           }
      };

  return (
    <div>
      <BaseButton
        variant="primary"
        size="normal"
        onClick={onClickDownload}
        disabled={isLoading}
      >
        <div className="flex gap-1 items-center">
          {isLoading ? (
            <>
              <div className="w-4 h-4 rounded-full border-b-2 border-white animate-spin"></div>
              <Text variant="semi-12">Downloading...</Text>
            </>
          ) : (
            <>
              <FileDownloadIcon />
              <Text variant="semi-12">Vehicle Overview Report</Text>
            </>
          )}
        </div>
      </BaseButton>

     
    </div>
  );
};

export default BtnVehicleReport;
